const cardItems = [
  {
    id: 1,
    title: '悬疑烧脑特辑',
    category: '电影专题',
    desc: '高智商犯罪、反转不断的精品悬疑片，挑战你的推理极限',
    img: 'https://readdy.ai/api/search-image?query=Dark%20mysterious%20detective%20office%20with%20cork%20board%20covered%20in%20red%20strings%20and%20crime%20scene%20photos%2C%20vintage%20desk%20lamp%20casting%20dramatic%20shadows%2C%20noir%20atmosphere%2C%20film%20noir%20lighting%20style%2C%20warm%20amber%20and%20deep%20shadow%20contrast%2C%20mysterious%20mood%2C%20cinematic%20quality&width=600&height=400&seq=card-thriller&orientation=landscape',
  },
  {
    id: 2,
    title: '国漫崛起之路',
    category: '动漫专题',
    desc: '从大圣归来到哪吒之魔童降世，见证国漫华丽蜕变',
    img: 'https://readdy.ai/api/search-image?query=Beautiful%20Chinese%20animation%20art%20style%20landscape%20with%20floating%20mountains%2C%20traditional%20ink%20wash%20painting%20aesthetic%2C%20mythical%20clouds%2C%20warm%20sunset%20colors%2C%20elegant%20oriental%20fantasy%20world%2C%20soft%20golden%20light%2C%20cinematic%20composition%2C%20artistic%20animation%20background&width=600&height=400&seq=card-anime&orientation=landscape',
  },
  {
    id: 3,
    title: '韩剧精选合集',
    category: '电视剧专题',
    desc: '高分韩剧一网打尽，从浪漫爱情到社会现实题材全覆盖',
    img: 'https://readdy.ai/api/search-image?query=Warm%20cozy%20Korean%20style%20living%20room%20with%20large%20TV%20screen%2C%20soft%20ambient%20lighting%2C%20comfortable%20couch%20with%20blanket%2C%20evening%20atmosphere%2C%20cinematic%20color%20grading%2C%20modern%20minimalist%20interior%2C%20warm%20tones%2C%20relaxing%20entertainment%20mood&width=600&height=400&seq=card-kdrama&orientation=landscape',
  },
  {
    id: 4,
    title: '经典港片回顾',
    category: '怀旧经典',
    desc: '周星驰、成龙、王家卫……重温港片黄金时代的永恒经典',
    img: 'https://readdy.ai/api/search-image?query=Retro%20Hong%20Kong%20street%20scene%20at%20night%20with%20neon%20signs%2C%20old%20cinema%20marquee%2C%20vintage%20movie%20posters%20on%20wall%2C%20rain%20soaked%20pavement%20reflecting%20colorful%20lights%2C%20nostalgic%201980s%20atmosphere%2C%20warm%20and%20vibrant%20tones%2C%20cinematic%20street%20photography%20style&width=600&height=400&seq=card-hkfilm&orientation=landscape',
  },
  {
    id: 5,
    title: '欧美高分剧集',
    category: '海外精选',
    desc: 'IMDb高分美剧英剧，权力的游戏、绝命毒师等口碑神作',
    img: 'https://readdy.ai/api/search-image?query=Cinematic%20premium%20TV%20series%20aesthetic%20with%20elegant%20home%20theater%20setup%2C%20large%20screen%20displaying%20dramatic%20scene%2C%20dark%20sophisticated%20interior%2C%20rich%20color%20palette%2C%20high%20contrast%20dramatic%20lighting%2C%20premium%20entertainment%20atmosphere%2C%20film%20poster%20collection%20on%20wall&width=600&height=400&seq=card-western&orientation=landscape',
  },
  {
    id: 6,
    title: '纪录片天地',
    category: '纪实佳作',
    desc: 'BBC、国家地理高分纪录片，探索自然人文与科技前沿',
    img: 'https://readdy.ai/api/search-image?query=Stunning%20aerial%20landscape%20of%20earth%20from%20above%20showing%20diverse%20terrains%2C%20majestic%20mountains%20and%20oceans%2C%20golden%20sunset%20light%2C%20nature%20documentary%20style%2C%20breathtaking%20wide%20angle%2C%20rich%20natural%20colors%2C%20cinematic%20nature%20photography&width=600&height=400&seq=card-doc&orientation=landscape',
  },
];

export default function CardsSection() {
  return (
    <section id="cards" className="w-full py-16 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-12">
          <span className="inline-block px-3 py-1 rounded-full bg-secondary-100 text-secondary-700 text-xs font-medium tracking-wide mb-3">
            专题策划
          </span>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900">
            影视专题
          </h2>
          <p className="text-foreground-500 text-sm md:text-base mt-2 max-w-lg mx-auto">
            精心策划的影视分类合集，按主题找到你想看的类型
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {cardItems.map((item) => (
            <article
              key={item.id}
              className="group bg-background-50 rounded-xl border border-background-200/70 overflow-hidden transition-all duration-300 hover:border-primary-200 cursor-pointer"
            >
              <div className="relative h-48 md:h-52 overflow-hidden bg-background-200">
                <img
                  src={item.img}
                  alt={item.title}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                  loading="lazy"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/50 via-transparent to-transparent"></div>
                <span className="absolute top-3 left-3 inline-block px-2.5 py-1 rounded-full bg-background-50/90 text-foreground-800 text-xs font-medium backdrop-blur-sm">
                  {item.category}
                </span>
              </div>
              <div className="p-5">
                <h3 className="font-heading text-base md:text-lg font-bold text-foreground-900 mb-2 group-hover:text-primary-600 transition-colors">
                  {item.title}
                </h3>
                <p className="text-foreground-500 text-sm leading-relaxed line-clamp-2">
                  {item.desc}
                </p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}